import { createSlice } from '@reduxjs/toolkit';

const environmentSlice = createSlice({
  name: 'environment',
  initialState: { environment: 'local' },
  reducers: {
    setEnvironment: (state, { payload: environment }) => {
      state.environment = environment;
    },
  },
});

export const getEnvironment = (state) => state.environment;

export const { setEnvironment } = environmentSlice.actions;

export default environmentSlice.reducer;
